// removed by extract-text-webpack-plugin
module.exports = {"busyLoading":"BusyLoading__busyLoading__1mRSa"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Loading/BusyLoading/BusyLoading.scss
// module id = 1613
// module chunks = 0